import { CustomLoader } from "../../modals/loader-subjects/loader";

export class PhotoLoader extends CustomLoader {
    items: any[] = [];
    name: string;
    // isNoImage: boolean;
}